export const ORDER_STATUS_CODE_TO_NAME = {
  UNREVIEWED: "Unreviewed",
  NO_REVIEW_REQUIRED: "No Review Required",
  CREDITS_REQUESTED: "Credits Requested",
  REVIEWED_ACCEPTED: "Accepted",
  REVIEWED_REJECTED: "Rejected",
};

export const DEFAULT_STATUS_FILTERS = [
  ORDER_STATUS_CODE_TO_NAME.REVIEWED_ACCEPTED,
  ORDER_STATUS_CODE_TO_NAME.REVIEWED_REJECTED,
  ORDER_STATUS_CODE_TO_NAME.UNREVIEWED,
];

